module.exports = __webpack_public_path__ + "img/pay-success@2x.9ae3bc4d.png";